import { Theme } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/styles";

export const useExamProgressBarStyles = makeStyles((theme: Theme) => createStyles({
  progressBar: {
    marginTop: theme.spacing(2),
    height: theme.spacing(1.5),
    borderRadius: theme.spacing(0.75),
  }
}))